<template>
  <div class="toolbar">
    <!--<div class="doyou" onclick="doyoo.util.openChat('g=10066289');return false">-->
      <!--<div class="box">-->
        <!--<span class="iconfont">&#xe65c;</span>-->
        <!--<i class="ibox">在</i><i class="ibox">线</i><i class="ibox">客</i><i class="ibox">服</i>-->
      <!--</div>-->
    <!--</div>-->
    <div class="top" @click="scrollTop">
      <div class="box">
        <span class="iconfont">&#xe649;</span>
        <!-- <a class="hoverbox" href="javascript:;"><i class="ib">返</i><i class="ib">回</i><i class="ib">顶</i><i class="ib">部</i></a> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .toolbar
    z-index 1000
    position fixed
    bottom 50px
    right 20px
    width 40px
    overflow hidden
    .doyou, .top
      width 40px
      cursor pointer
      margin 4px 0
      border-radius 20px
      overflow hidden
      background-color rgb(43, 158, 252)
    .doyou:hover,.top:hover
        background-color rgb(0, 104, 183)
        transition background 0.2s
    .box
      width 40px
      border-radius 20px
      transition all .4s
      span.iconfont
        display block
        width 40px
        height 40px
        line-height 40px
        padding-top 2px
        padding-left 3px
        font-size 26px
        text-align center
        color #fff
        letter-spacing 3px
      .ibox
        display block
        position relative
        font-size 14px
        display inline-block
        width 40px
        text-align center
        font-style normal
        color #fff
      .hoverbox
        display block
        position relative
        width 40px
        height: 40px
        text-align center
        color #fff
        padding 6px 3px
        font-size 0
        border-radius 20px
      .ib
        display inline-block
        width 14px
        font-style normal
        text-align center
        height 14px
        font-size 12px
        line-height 14px
        text-align center
    .doyou
      margin-bottom 10px
      .box
        padding-bottom 10px
    .top
      height: 40px;
      .box
        height: 80px;
      // &:hover
      //   background-color rgb(0, 104, 183)
        // .box
        //   transform translate(0, -40px)
</style>




// WEBPACK FOOTER //
// toolbar.vue?d806b0b6